document.addEventListener('DOMContentLoaded', () => {

  // Popup modal
  const trigger  = document.querySelector('.jkl-newsletter-trigger');
  const overlay  = document.querySelector('.jkl-newsletter-overlay-popup');
  const closeBtn = overlay?.querySelector('.close-btn');

  const openPopup = () => {
    if (trigger && overlay) {
      trigger.style.display = 'none';
      overlay.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    }
  };

  const closePopup = () => {
    if (trigger && overlay) {
      overlay.style.display = 'none';
      trigger.style.display = 'flex';
      document.body.style.overflow = '';
    }
  };

  trigger?.addEventListener('click', openPopup);
  closeBtn?.addEventListener('click', closePopup);
  overlay?.addEventListener('click', (e) => {
    if (e.target === overlay) closePopup();
  });

  // Toast banner
  const TOAST_AUTO_CLOSE_MS = 6000;

  const toast      = document.getElementById('jkl-newsletter-toast');
  const toastMsg   = document.getElementById('jkl-newsletter-toast-message');
  const toastClose = toast?.querySelector('.jkl-newsletter-toast__close');

  let toastTimer = null;

  const showToast = (message, type = 'success') => {
    if (!toast || !toastMsg) return;
    toastMsg.textContent = message;
    toast.classList.remove('jkl-newsletter-toast--success', 'jkl-newsletter-toast--error');
    toast.classList.add(`jkl-newsletter-toast--${type}`);
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, TOAST_AUTO_CLOSE_MS);
  };

  const hideToast = () => {
    if (!toast) return;
    toast.hidden = true;
    clearTimeout(toastTimer);
  };

  toastClose?.addEventListener('click', hideToast);

  // Show error or success messages from server-side after reload
  const detectors = [
    {
      successSel: '.jkl-newsletter__message--success',
      errorSel:   '.jkl-newsletter__message--error',
    },
    {
      successSel: '.jkl-footer-newsletter__message--success',
      errorSel:   '.jkl-footer-newsletter__message--error',
    },
  ];

  detectors.forEach(({ successSel, errorSel }) => {
    const successEl = document.querySelector(successSel);
    const errorEl   = document.querySelector(errorSel);

    if (successEl) {
      const message = successEl.querySelector('p')?.textContent?.trim() || successEl.textContent?.trim();
      showToast(message, 'success');
    } else if (errorEl) {
      const message = errorEl.textContent?.trim();
      showToast(message, 'error');
    }
  });

});
